module.exports = __webpack_public_path__ + "img/bq.c16e1bd5.svg";